import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";

import Collapse from "components/Collapse";
import Stack from "components/Stack";
import Text from "components/Text";

import { ITransaction } from "entities/Deal/sdk";

import DebtTransactionCollapse from "./DebtTransactionCollapse";
import EquityTransactionCollapse from "./EquityTransactionCollapse";
import GrantAndOtherTransactionCollapse from "./GrantAndOtherTransactionCollapse";
import TaxCreditAllocationTransactionCollapse from "./TaxCreditAllocationTransactionCollapse";
import TransactionCollapseTitlesRow from "./TransactionCollapseTitlesRow";

export interface ITransactionCollapse {
  transaction: ITransaction;
  open: boolean;
  isLast: boolean;
}
const TransactionCollapse = ({
  transaction,
  open,
  isLast,
}: ITransactionCollapse) => (
  <Collapse in={open} timeout="auto" sx={{ gridColumn: "1 / -1" }}>
    <Stack flexDirection="row">
      <Stack
        display="grid"
        gridTemplateColumns="1fr 1fr"
        padding={theme.spacing(5, 8)}
        sx={{
          flexBasis: "60%",
          gridAutoRows: "min-content",
        }}
      >
        {!_.isNil(transaction.equity_transaction) && (
          <EquityTransactionCollapse
            equityTransaction={transaction.equity_transaction}
          />
        )}
        {!_.isNil(transaction.debt_transaction) && (
          <DebtTransactionCollapse
            debtTransaction={transaction.debt_transaction}
          />
        )}
        {!_.isNil(transaction.tax_credit_allocation_transaction) && (
          <TaxCreditAllocationTransactionCollapse
            taxCreditAllocationTransaction={
              transaction.tax_credit_allocation_transaction
            }
          />
        )}
        {!_.isNil(transaction.grant_transaction) && (
          <GrantAndOtherTransactionCollapse
            specificTransaction={transaction.grant_transaction}
          />
        )}
        {!_.isNil(transaction.other_transaction) && (
          <GrantAndOtherTransactionCollapse
            specificTransaction={transaction.other_transaction}
          />
        )}
      </Stack>

      <Stack gap={2} padding={theme.spacing(5, 8)} sx={{ flexBasis: "40%" }}>
        <Text sx={{ color: colors.gray40 }}>Description</Text>
        <Text>
          {!_.isNil(transaction.description) ? transaction.description : "N/A"}
        </Text>
      </Stack>
    </Stack>
    {!isLast && <TransactionCollapseTitlesRow isHeading={false} />}
  </Collapse>
);

export default TransactionCollapse;
